import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

// Suppress browser extension conflicts (crypto wallet extensions)
// These errors are harmless and shouldn't crash the app
const originalError = console.error;
console.error = (...args: any[]) => {
  const errorMessage = args.join(' ');
  // Ignore window.ethereum conflicts from browser extensions
  if (errorMessage.includes('ethereum') && errorMessage.includes('getter')) {
    return; // Silently ignore extension conflicts
  }
  originalError.apply(console, args);
};

// Catch unhandled errors from browser extensions
window.addEventListener('error', (event) => {
  if (event.message?.includes('ethereum') || event.filename?.includes('chrome-extension')) {
    event.preventDefault(); // Prevent the error from showing
    return false;
  }
});

window.addEventListener('unhandledrejection', (event) => {
  if (event.reason?.message?.includes('ethereum') || 
      event.reason?.stack?.includes('chrome-extension')) {
    event.preventDefault(); // Prevent the error from showing
    return false;
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);